export const CHECKLISTEN_AUTH_API_BASE =
  import.meta.env.VITE_AUTH_API_BASE ?? '/shop/api/v1'
